


























































































































import { Component, Vue, Watch, Emit } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import SolicitacaoCirurgiaStore from '@/components/SolicitacaoCirurgia/store/SolicitacaoCirurgiaStore'
import { timeout } from '@/utils/common'
import moment from 'moment'

@Component
export default class ComponentModalBuscarPaciente extends Vue {
  sel: any = {}
  loadSearch: boolean = false
  loadUsarPaciente: boolean = false
  paciente: string = ''
  dataNascimento: string = ''
  paginationProps: any = {
    descending: false,
    page: 1,
    rowsPerPage: 10,
    sortBy: null,
    totalItems: 0,
    rowsPerPageItems: [25, 50, 100, 200],
  }

  buscarPacienteTableHeader: any[] = [
    { text: '', value: '', sortable: false },
    { text: 'Nome', value: 'nome', sortable: false },
    { text: 'CPF', value: 'cpf', sortable: false },
    { text: 'Data de nascimento', value: 'dataNascimento', sortable: false },
    { text: 'Convênio', value: 'convenioId', sortable: false },
  ]

  get getTemplate() {
    return this.getSolicitacaoCirurgiaStore.template.formulario
  }

  get documentacaoObrigatoriaDoPaciente() {
    return !!(this.getTemplate.documentacaoObrigatoriaDoPaciente && this.getTemplate.documentacaoObrigatoriaDoPaciente.obrigatorio)
  }

  get pacientes() {
    return this.getSolicitacaoCirurgiaStore.pacientesLista
  }

  get getSolicitacaoCirurgiaStore() {
    return getModule(SolicitacaoCirurgiaStore, this.$store)
  }

  get loadingSearch() {
    return this.loadSearch
  }

  set loadingSearch(value: boolean) {
    this.loadSearch = value
  }

  get loadingUsarPaciente() {
    return this.loadUsarPaciente
  }

  set loadingUsarPaciente(value: boolean) {
    this.loadUsarPaciente = value
  }

  get selected() {
    return this.sel
  }

  set selected(value: any) {
    this.sel = value
  }

  get buscarPaciente() {
    return this.getSolicitacaoCirurgiaStore.modal.buscarPaciente
  }

  formatCPFOnly(c: string) {
    if (!c) return '-'
    return `${c.substring(0, 3)}.${c.substring(3, 6)}.${c.substring(6, 9)}-${c.substring(9, 11)}`
  }

  formatBirthday(value: string) {
    if (!value) return '-'
    return moment(value).format('DD/MM/YYYY')
  }

  formatConvenio(convenioId: string) {
    const convenio = this.getSolicitacaoCirurgiaStore.convenios.find((e: any) => e.id === convenioId)
    return convenio ? convenio.nome : ''
  }

  closeModalBuscarPaciente() {
    this.selected = {}
    this.getSolicitacaoCirurgiaStore.clearPacientesLista()
    this.getSolicitacaoCirurgiaStore.setShowModalBuscarPaciente(false)
  }

  async search() {
    if (this.paciente.length < 3 || this.dataNascimento.length < 10) return
    this.loadingSearch = true

    const filterParams: {
      nome: string;
      dataNascimento: string;
      convenioId?: string;
    } = {
      nome: this.paciente,
      dataNascimento: this.dataNascimento,
    }

    if (this.patientData && this.patientData.convenioId) {
      filterParams.convenioId = this.patientData.convenioId
    }

    await this.getSolicitacaoCirurgiaStore.getPacienteInfoByNomeAndDataNascimento(filterParams)
    this.loadingSearch = false
  }

  get surgerySolicitation() {
    return this.getSolicitacaoCirurgiaStore.solicitacaoCirurgia
  }

  get patientData() {
    return this.surgerySolicitation.paciente
  }

  selectPaciente() {
    this.loadingUsarPaciente = true

    this.getSolicitacaoCirurgiaStore.resetPaciente()
    this.getSolicitacaoCirurgiaStore.setConsultaPacienteNome(this.selected)

    this.$emit('setCpfPaciente', false)

    const { convenioId } = this.selected

    if (convenioId) {
      this.$emit('setConvenioId', convenioId)
    }

    this.closeModalBuscarPaciente()
    this.loadingUsarPaciente = false
  }

  @Watch('buscarPaciente')
  onChangeBuscarPaciente(value) {
    if (!value) {
      this.selected = {}
      this.getSolicitacaoCirurgiaStore.clearPacientesLista()
      this.paciente = ''
      this.dataNascimento = ''
    }
  }
}
